<template>
  <RevDrawer name="SUMMARY_SERVICE_FEE" :title="i18n(translations.modalTitle)">
    <template #trigger="{ open }">
      <slot name="trigger" :open>
        <RevLink @click="open">
          <span class="block text-left" :class="[triggerLinkClass]">
            {{ i18n(translations.modalTrigger) }}
          </span>
        </RevLink>
      </slot>
    </template>
    <template #body>
      <div class="flex h-full flex-col justify-between">
        <div>
          <RevIllustration
            alt=""
            class="w-full"
            :height="158"
            src="/img/checkout/qualityAssuranceModal.svg"
            :width="328"
          />
          <div class="mt-32">
            <h3 class="heading-3">
              {{ i18n(translations.alternativeTitle) }}
            </h3>
            <div class="body-1 mt-12">
              {{ i18n(translations.alternativeDescription) }}
            </div>
          </div>

          <ContentRow
            class="mt-24"
            :labels="[i18n(translations.alternativeFirstSectionLabelNew)]"
            :title="i18n(translations.alternativeFirstSectionTitle)"
          >
            <IconQuality />
          </ContentRow>
          <ContentRow
            class="mt-24"
            :labels="[i18n(translations.alternativeSecondSectionLabelNew)]"
            :title="i18n(translations.alternativeSecondSectionTitleNew)"
          >
            <IconBackMarketApp />
          </ContentRow>
          <ContentRow
            class="mt-24"
            :labels="[i18n(translations.alternativeThirdSectionLabelNew)]"
            :title="i18n(translations.alternativeThirdSectionTitleNew)"
          >
            <IconRocket />
          </ContentRow>
        </div>
      </div>
    </template>
    <template v-if="withLink" #footer>
      <RevButton
        full-width="always"
        target="_blank"
        :to="faqArticleLink"
        variant="secondary"
      >
        {{ i18n(translations.learnMore) }}
      </RevButton>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import { useZendeskFaqBaseUrl } from '@backmarket/nuxt-layer-base/composables/useZendeskFaqBaseUrl'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { IconBackMarketApp } from '@ds/icons/IconBackMarketApp'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconRocket } from '@ds/icons/IconRocket'

import ContentRow from '../ContentRow.vue'

import translations from './ServiceFeeModal.translations'

const i18n = useI18n()
const { ZENDESK_QUALITY_ASSURANCE_FEE_ARTICLE } = useRuntimeConfig().public
const { zendeskFaqBaseUrl } = useZendeskFaqBaseUrl()

const faqArticleLink = `${zendeskFaqBaseUrl}/articles/${ZENDESK_QUALITY_ASSURANCE_FEE_ARTICLE}`

withDefaults(
  defineProps<{
    withLink?: boolean
    triggerLinkClass?: string
  }>(),
  { withLink: true, triggerLinkClass: 'body-2' },
)
</script>
